import { CountryCodeByAppDomain, CurrencyByCountryCode } from '@pegasus/config';
import { Currency } from '@pegasus/translation';
export const track = (type, payload = {}) => {
    const trackingInfo = { ...payload, event: type };
    return typeof window !== 'undefined' && window.dataLayer && window.dataLayer.push(trackingInfo);
};
const getCurrencyCode = () => {
    const appDomain = (typeof window !== 'undefined' && window.APPDOMAIN);
    const countryCode = CountryCodeByAppDomain[appDomain];
    return CurrencyByCountryCode[countryCode] || Currency.EUR;
};
export const getTrackingData = () => {
    // since recoveredCart is accessible from a number of page, following ensures we ONLY select these fields
    // from the 'TRACK_DATA' which can have several other fields depending upon the page context.
    /* eslint-disable */
    const selectTrackables = ({ clientID, client_type, country, domain, gender, generatedUrl, gtm, languageId, lead, lead_lp, lp_name, lp_redirect, myfilter, nwl_consent, nwl_status, social, userrole, visitorExistingCustomer, visitorID, zalando_type, }) => ({
        clientID,
        client_type,
        country,
        domain,
        gender,
        generatedUrl,
        gtm,
        languageId,
        lead,
        lead_lp,
        lp_name,
        lp_redirect,
        myfilter,
        nwl_consent,
        nwl_status,
        social,
        userrole,
        visitorExistingCustomer,
        visitorID,
        zalando_type,
    });
    /* eslint-enable */
    if (typeof window !== 'undefined' && window.dataLayer) {
        const trackData = window.dataLayer.find(trackEvent => trackEvent.event === 'TRACK_DATA') || {};
        return selectTrackables(trackData);
    }
};
export const getTrackingDataReserveAgain = (recoveredItem, addToCartSource) => {
    const trackData = getTrackingData() || {};
    return {
        ...trackData,
        type: 'product',
        component: addToCartSource,
        productName: recoveredItem.name,
        productStatus: recoveredItem.stockStatus,
        productSku: recoveredItem.configSku,
        productSize: recoveredItem.size,
        productprice: recoveredItem.specialPrice,
        productQty: 1,
        expiredItem: 1,
        ecommerce: {
            currencyCode: getCurrencyCode(),
            add: {
                products: [
                    {
                        name: recoveredItem.name,
                        id: recoveredItem.configSku,
                        price: recoveredItem.specialPrice,
                        brand: recoveredItem.brand,
                        quantity: 1,
                        dimension1: recoveredItem.size,
                        dimension4: recoveredItem.campaignIdentifier,
                    },
                ],
            },
        },
        reco: 0,
        recommendedSize: 'No recommendation',
        recommendedSizeStatus: 'No recommendation',
    };
};
//# sourceMappingURL=tracking.js.map